
import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import styled from "@emotion/styled"
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

const SpecsContainer = styled(motion.div)`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 1.5rem;
  backdrop-filter: blur(10px);
  margin-top: 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`

const StyledAccordion = styled(Accordion)`
  background: transparent !important;
  color: #ffffff !important;
  box-shadow: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:before {
    display: none;
  }

  &:last-child {
    border-bottom: none;
  }
`

const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0 0.5rem;
  min-height: 48px !important;

  .MuiAccordionSummary-content {
    margin: 0.5rem 0 !important;
  }

  .MuiSvgIcon-root {
    color: #00ff88;
    font-size: 1.2rem;
  }
`

const SpecKey = styled.span`
  font-size: 1rem;
  font-weight: 600;
  color: #00ff88;
 ::first-letter {
  text-transform: uppercase;

  }
`

const SpecValue = styled.div`
  color: #ffffff;
  font-size: 0.9rem;
  margin-top: 0.25rem;
`

const SpecDetails = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  line-height: 1.4;
 ::first-letter {
  text-transform: uppercase;
}

`

const specs = [
  {
    key: "Cuadro",
    value: "Carbono T1000",
    details: "Cuadro ultraligero de carbono T1000 para máxima rigidez y mínimo peso.",
  },
  {
    key: "Grupo",
    value: "Shimano Ultegra Di2",
    details: "Cambios electrónicos precisos y fiables para un rendimiento óptimo.",
  },
  {
    key: "Ruedas",
    value: "Carbon Aero 50mm",
    details: "Ruedas de perfil aerodinámico para mayor velocidad y eficiencia.",
  },
  {
    key: "Peso",
    value: "7.2 kg",
    details: "Peso total de la bicicleta, incluyendo todos los componentes.",
  },
]

export function SpecsSection({ specs }) {
  const [expanded, setExpanded] = useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <SpecsContainer initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
      <h3>Especificaciones Técnicas</h3>
      {specs?.map((spec, index) => (
        <StyledAccordion
          key={index}
          expanded={expanded === `panel${index}`}
          onChange={handleChange(`panel${index}`)}
        >
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${index}bh-content`}
            id={`panel${index}bh-header`}
          >
            <SpecKey>{spec[0]}</SpecKey>
          </StyledAccordionSummary>
          <AccordionDetails>
            <AnimatePresence>
              {expanded === `panel${index}` && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <SpecDetails>{spec[1]}</SpecDetails>
                </motion.div>
              )}
            </AnimatePresence>
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </SpecsContainer>
  )
}

